import axios from 'axios';
import { Invoice } from './paymentService';

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001/api') + '/admin';

class InvoiceService {
  private getAuthHeaders() {
    const tokens = localStorage.getItem('cnf_auth_tokens');
    if (tokens) {
      const parsed = JSON.parse(tokens);
      return {
        headers: {
          Authorization: `Bearer ${parsed.accessToken}`,
        },
      };
    }
    return {
      headers: {},
    };
  }

  async getAllInvoices(): Promise<Invoice[]> {
    const response = await axios.get(`${API_BASE_URL}/invoices`, this.getAuthHeaders());
    return response.data;
  }

  async getInvoiceById(id: number): Promise<Invoice> {
    const response = await axios.get(`${API_BASE_URL}/invoices/${id}`, this.getAuthHeaders());
    return response.data;
  }

  async getInvoiceByNumber(invoiceNumber: string): Promise<Invoice> {
    const response = await axios.get(`${API_BASE_URL}/invoices/number/${invoiceNumber}`, this.getAuthHeaders());
    return response.data;
  }

  async getInvoiceByWorkOrderId(workOrderId: number): Promise<Invoice | null> {
    try {
      const response = await axios.get(`${API_BASE_URL}/invoices/work-order/${workOrderId}`, this.getAuthHeaders());
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async archiveInvoice(id: number): Promise<void> {
    await axios.post(`${API_BASE_URL}/invoices/${id}/archive`, {}, this.getAuthHeaders());
  }

  async sendInvoiceEmail(params: {
    invoiceId: number;
    pdfBuffer: string; // base64 encoded PDF
    customerEmail: string;
    customerName?: string;
  }): Promise<{ success: boolean; message: string }> {
    const response = await axios.post(
      `${API_BASE_URL}/invoices/${params.invoiceId}/send`,
      {
        pdfBuffer: params.pdfBuffer,
        customerEmail: params.customerEmail,
        customerName: params.customerName,
      },
      this.getAuthHeaders()
    );
    return response.data;
  }
}

export const invoiceService = new InvoiceService();
